import { EngagementAnalytics } from '@/components/admin/analyticsV2/engagement';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(EngagementAnalytics, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});
